import React, { useEffect, useState } from "react";
import "./hall-menu-component.css";
import foodImg from "../../../../Assets/Hall/foodImg.jpg";
import kosutaLogo from "../../../../Assets/logo.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

const HallMenuData = [
  // // 32€ menu start
  // {
  //   title: "Salata",
  //   engTitle: "Salads",
  //   category: "32",
  //   subTitle: [
  //     {
  //       title: "Bašta salata",
  //       engTitle: "Garden salad",
  //       paragraphs: [
  //         {
  //           title: "(paradajz, krastavac, kupus, ljuta paprika, mladi luk)",
  //           engTitle: "(tomato, cucumber, cabbage, hot pepper, spring onion)",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "Čorba",
  //   engTitle: "Soup",
  //   category: "32",
  //   subTitle: [
  //     {
  //       title: "Teleća",
  //       engTitle: "Veal soup",
  //     },
  //   ],
  // },
  // {
  //   title: "Glavno jelo",
  //   engTitle: "Main course",
  //   category: "32",
  //   subTitle: [
  //     {
  //       title: "Roštilj",
  //       engTitle: "Grill",
  //       paragraphs: [
  //         {
  //           title:
  //             "Pljeskavica, Ćevapi, Vešalica, Pileće belo meso, Dimljeni vrat, Domaća kobasica, Pileći batak",
  //           engTitle:
  //             "Serbian burger (pljeskavica), Ćevapi, Pork hanger steak, Chicken breast, Smoked pork neck, Homemade sausage, Chicken drumstick",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Teleći medaljoni sa vrganjima i šampinjonima",
  //       engTitle: "Veal medallions with porcini and champignon mushrooms",
  //     },
  //     {
  //       title: "Pohovana piletina",
  //       engTitle: "Breaded chicken",
  //     },
  //   ],
  // },
  // {
  //   title: "Piće",
  //   engTitle: "Drinks",
  //   category: "32",
  //   subTitle: [
  //     {
  //       title: "Rakije",
  //       engTitle: "Rakija",
  //       paragraphs: [
  //         {
  //           title: "Dunja, Kajsija, Šljiva, Loza, Viljamovka",
  //           engTitle: "Quince, Apricot, Plum, Grape, Williams pear",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Medene rakije",
  //       engTitle: "Honey rakija",
  //       paragraphs: [
  //         {
  //           title: "Malina, Dunja",
  //           engTitle: "Raspberry, Quince",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Vina",
  //       engTitle: "Wine",
  //       paragraphs: [
  //         {
  //           title:
  //             "Crveno vino 0,7l, Roze vino 0,7l, Belo vino 0,7l (Vinarija Oplenac)",
  //           engTitle:
  //             "Red wine 0.7l, Rosé wine 0.7l, White wine 0.7l (Oplenac Winery)",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Pivo",
  //       engTitle: "Beer",
  //       paragraphs: [
  //         {
  //           title: "Lav Premium 0,33l, Lav točeno 0,33l, Tuborg 0.33l",
  //           engTitle: "Lav Premium 0.33l, Lav draft 0.33l, Tuborg 0.33l",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Voda",
  //       engTitle: "Water",
  //       paragraphs: [
  //         {
  //           title: "Knjaz Miloš gazirana, Aqua Viva negazirana",
  //           engTitle:
  //             "Knjaz Miloš sparkling mineral water, Aqua Viva still water",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Sokovi",
  //       engTitle: "Soft drinks",
  //       paragraphs: [
  //         {
  //           title:
  //             "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Jabuka, Jagoda, Breskva, Đus",
  //           engTitle:
  //             "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Apple, Strawberry, Peach, Orange juice",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Ceđeni sokovi",
  //       engTitle: "Fresh juices",
  //       paragraphs: [
  //         {
  //           title: "Limunada",
  //           engTitle: "Lemonade",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Ostala pića",
  //       engTitle: "Other drinks",
  //       paragraphs: [
  //         {
  //           title: "Vermut, Vodka, Vinjak, Džin, Pelinkovac",
  //           engTitle: "Vermouth, Vodka, Brandy, Gin, Pelinkovac",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Kafa",
  //       engTitle: "Coffee",
  //       paragraphs: [
  //         {
  //           title: "Kafa espresso, Nes kafa",
  //           engTitle: "Espresso, Nescafé",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Strana pića",
  //       engTitle: "International spirits",
  //       paragraphs: [
  //         {
  //           title: "Martini, Campari, Tequila, Jägermeister",
  //           engTitle: "Martini, Campari, Tequila, Jägermeister",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // // 32€ end

  // 38€ start
  {
    title: "Predjelo",
    engTitle: "Appetizers",
    category: "38",
    subTitle: [
      {
        title: "Mesni proizvodi",
        engTitle: "Cured meats",
        paragraphs: [
          {
            title:
              "Pršuta Njeguška, Svinjska pečenica, Goveđa pečenica, Kulen, Budimska",
            engTitle:
              "Njeguši prosciutto, Pork loin, Beef prosciutto, Kulen sausage, Budim sausage",
          },
        ],
      },
      {
        title: "Sirevi",
        engTitle: "Cheeses",
        paragraphs: [
          {
            title: "Kajmak, Mladi sir, Urnebes, Kačkavalj",
            engTitle:
              "Kajmak, Fresh cheese, Spicy cheese spread (Urnebes), Kashkaval",
          },
        ],
      },
      {
        title: "Dodaci",
        engTitle: "Extras",
        paragraphs: [
          {
            title: "Masline",
            engTitle: "Olives",
          },
        ],
      },
      {
        title: "Peciva",
        engTitle: "Pastries",
        paragraphs: [
          {
            title: "Proja",
            engTitle: "Cornbread",
          },
        ],
      },
    ],
  },
  {
    title: "Salata",
    engTitle: "Salads",
    category: "38",
    subTitle: [
      {
        title: "Sezonska salata",
        engTitle: "Seasonal salad",
        paragraphs: [
          {
            title: "Krastavac i paradajz",
            engTitle: "Cucumber and tomato",
          },
        ],
      },
      {
        title: "Bašta salata",
        engTitle: "Garden salad",
        paragraphs: [
          {
            title: "Paradajz, krastavac, kupus, ljuta paprika, mladi luk",
            engTitle: "Tomato, cucumber, cabbage, hot pepper, spring onion",
          },
        ],
      },
    ],
  },
  {
    title: "Čorba",
    engTitle: "Soup",
    category: "38",
    subTitle: [
      {
        title: "Teleća",
        engTitle: "Veal soup",
      },
    ],
  },
  {
    title: "Glavno jelo",
    engTitle: "Main course",
    category: "38",
    subTitle: [
      {
        title: "Roštilj",
        engTitle: "Grill",
        paragraphs: [
          {
            title:
              "Pljeskavica, Ćevapi, Vešalica, Pileće belo meso, Dimljeni vrat, Domaća kobasica, Pileći batak",
            engTitle:
              "Serbian burger (pljeskavica), Ćevapi, Pork hanger steak, Chicken breast, Smoked pork neck, Homemade sausage, Chicken drumstick",
          },
        ],
      },
      {
        title: "Teleći medaljoni sa vrganjima i šampinjonima",
        engTitle: "Veal medallions with porcini and champignon mushrooms",
      },
      {
        title: "Pohovana piletina",
        engTitle: "Breaded chicken",
      },
      {
        title: "Prilog",
        engTitle: "Side dish",
        paragraphs: [
          {
            title: "Pekarski krompir",
            engTitle: "Baked potatoes",
          },
        ],
      },
    ],
  },
  {
    title: "Razne vrste peciva",
    engTitle: "Various types of bread and pastries",
    category: "38",
  },
  {
    title: "Piće",
    engTitle: "Drinks",
    category: "38",
    subTitle: [
      {
        title: "Rakije",
        engTitle: "Rakija",
        paragraphs: [
          {
            title: "Dunja, Kajsija, Šljiva, Loza, Viljamovka",
            engTitle: "Quince, Apricot, Plum, Grape, Williams pear",
          },
        ],
      },
      {
        title: "Medene rakije",
        engTitle: "Honey rakija",
        paragraphs: [
          {
            title: "Malina, Dunja",
            engTitle: "Raspberry, Quince",
          },
        ],
      },
      {
        title: "Vina",
        engTitle: "Wine",
        paragraphs: [
          {
            title:
              "Crveno vino 0,7l, Roze vino 0,7l, Belo vino 0,7l (Vinarija Oplenac)",
            engTitle:
              "Red wine 0.7l, Rosé wine 0.7l, White wine 0.7l (Oplenac Winery)",
          },
        ],
      },
      {
        title: "Pivo",
        engTitle: "Beer",
        paragraphs: [
          {
            title:
              "Lav Premium 0,33l, Lav točeno 0,33l, Tuborg 0.33l, Budweiser tamno 0.33l",
            engTitle:
              "Lav Premium 0.33l, Lav draft 0.33l, Tuborg 0.33l, Budweiser dark 0.33l",
          },
        ],
      },
      {
        title: "Voda",
        engTitle: "Water",
        paragraphs: [
          {
            title: "Knjaz Miloš gazirana, Aqua Viva negazirana",
            engTitle:
              "Knjaz Miloš sparkling mineral water, Aqua Viva still water",
          },
        ],
      },
      {
        title: "Sokovi",
        engTitle: "Soft drinks",
        paragraphs: [
          {
            title:
              "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Jabuka, Jagoda, Breskva, Đus",
            engTitle:
              "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Apple, Strawberry, Peach, Orange juice",
          },
        ],
      },
      {
        title: "Ceđeni sokovi",
        engTitle: "Fresh juices",
        paragraphs: [
          {
            title: "Limunada",
            engTitle: "Lemonade",
          },
        ],
      },
      {
        title: "Ostala pića",
        engTitle: "Other drinks",
        paragraphs: [
          {
            title: "Vermut, Vodka, Vinjak, Džin, Pelinkovac",
            engTitle: "Vermouth, Vodka, Brandy, Gin, Pelinkovac",
          },
        ],
      },
      {
        title: "Kafa",
        engTitle: "Coffee",
        paragraphs: [
          {
            title: "Kafa domaća, Kafa espresso, Nes kafa",
            engTitle: "Turkish coffee, Espresso, Nescafé",
          },
        ],
      },
      {
        title: "Strana pića",
        engTitle: "International spirits",
        paragraphs: [
          {
            title: "Martini, Campari, Tequila, Jägermeister, Ballantine’s",
            engTitle: "Martini, Campari, Tequila, Jägermeister, Ballantine’s",
          },
        ],
      },
    ],
  },
  // 38€ end

  // 42€ start
  {
    title: "Predjelo",
    engTitle: "Appetizers",
    category: "42",
    subTitle: [
      {
        title: "Mesni proizvodi",
        engTitle: "Cured meats",
        paragraphs: [
          {
            title:
              "Pršuta Njeguška, Svinjska pečenica, Goveđa pečenica, Kulen, Budimska",
            engTitle:
              "Njeguši prosciutto, Pork loin, Beef prosciutto, Kulen sausage, Budim sausage",
          },
        ],
      },
      {
        title: "Sirevi",
        engTitle: "Cheeses",
        paragraphs: [
          {
            title: "Kajmak, Mladi sir, Urnebes, Kačkavalj",
            engTitle:
              "Kajmak, Fresh cheese, Spicy cheese spread (Urnebes), Kashkaval",
          },
        ],
      },
      {
        title: "Dodaci",
        engTitle: "Extras",
        paragraphs: [
          {
            title: "Masline",
            engTitle: "Olives",
          },
        ],
      },
      {
        title: "Peciva",
        engTitle: "Pastries",
        paragraphs: [
          {
            title: "Proja, Pite sa mesom, Pite sa sirom",
            engTitle: "Cornbread, Meat pie, Cheese pie",
          },
        ],
      },
    ],
  },
  {
    title: "Salata",
    engTitle: "Salads",
    category: "42",
    subTitle: [
      {
        title: "Sezonska salata",
        engTitle: "Seasonal salad",
        paragraphs: [
          {
            title: "Krastavac i paradajz",
            engTitle: "Cucumber and tomato",
          },
        ],
      },
      {
        title: "Bašta salata",
        engTitle: "Garden salad",
        paragraphs: [
          {
            title: "Paradajz, krastavac, kupus, ljuta paprika, mladi luk",
            engTitle: "Tomato, cucumber, cabbage, hot pepper, spring onion",
          },
        ],
      },
    ],
  },
  {
    title: "Čorba",
    engTitle: "Soup",
    category: "42",
    subTitle: [
      {
        title: "Teleća",
        engTitle: "Veal soup",
      },
    ],
  },
  {
    title: "Međujelo",
    engTitle: "Intermediate course",
    category: "42",
    subTitle: [
      {
        title: "Punjena sušena paprika (sa mesom) + pavlaka",
        engTitle: "Stuffed dried pepper (with meat) + sour cream",
      },
    ],
  },
  {
    title: "Glavno jelo",
    engTitle: "Main course",
    category: "42",
    subTitle: [
      {
        title: "Roštilj",
        engTitle: "Grill",
        paragraphs: [
          {
            title:
              "Pljeskavica, Ćevapi, Vešalica, Pileće belo meso, Dimljeni vrat, Domaća kobasica, Pileći batak",
            engTitle:
              "Serbian burger (pljeskavica), Ćevapi, Pork hanger steak, Chicken breast, Smoked pork neck, Homemade sausage, Chicken drumstick",
          },
        ],
      },
      {
        title: "Teleći medaljoni sa vrganjima i šampinjonima",
        engTitle: "Veal medallions with porcini and champignon mushrooms",
      },
      {
        title: "Ćuretina sa mlincima",
        engTitle: "Turkey with mlinci",
      },
      {
        title: "Prilog",
        engTitle: "Side dish",
        paragraphs: [
          {
            title: "Pekarski krompir",
            engTitle: "Baked potatoes",
          },
        ],
      },
    ],
  },
  {
    title: "Razne vrste peciva",
    engTitle: "Various types of bread and pastries",
    category: "42",
  },
  {
    title: "Piće",
    engTitle: "Drinks",
    category: "42",
    subTitle: [
      {
        title: "Rakije",
        engTitle: "Rakija",
        paragraphs: [
          {
            title: "Dunja, Kajsija, Šljiva, Loza, Viljamovka",
            engTitle: "Quince, Apricot, Plum, Grape, Williams pear",
          },
        ],
      },
      {
        title: "Medene rakije",
        engTitle: "Honey rakija",
        paragraphs: [
          {
            title: "Malina, Dunja",
            engTitle: "Raspberry, Quince",
          },
        ],
      },
      {
        title: "Vina",
        engTitle: "Wine",
        paragraphs: [
          {
            title:
              "Crveno vino 0,7l, Roze vino 0,7l, Belo vino 0,7l (Vinarija Oplenac)",
            engTitle:
              "Red wine 0.7l, Rosé wine 0.7l, White wine 0.7l (Oplenac Winery)",
          },
        ],
      },
      {
        title: "Pivo",
        engTitle: "Beer",
        paragraphs: [
          {
            title:
              "Lav Premium 0,33l, Lav točeno 0,33l, Tuborg 0.33l, Budweiser tamno 0.33l, Carlsberg 0.25l",
            engTitle:
              "Lav Premium 0.33l, Lav draft 0.33l, Tuborg 0.33l, Budweiser dark 0.33l, Carlsberg 0.25l",
          },
        ],
      },
      {
        title: "Voda",
        engTitle: "Water",
        paragraphs: [
          {
            title: "Knjaz Miloš gazirana, Aqua Viva negazirana",
            engTitle:
              "Knjaz Miloš sparkling mineral water, Aqua Viva still water",
          },
        ],
      },
      {
        title: "Sokovi",
        engTitle: "Soft drinks",
        paragraphs: [
          {
            title:
              "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Jabuka, Jagoda, Breskva, Đus",
            engTitle:
              "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Apple, Strawberry, Peach, Orange juice",
          },
        ],
      },
      {
        title: "Ceđeni sokovi",
        engTitle: "Fresh juices",
        paragraphs: [
          {
            title: "Limunada",
            engTitle: "Lemonade",
          },
        ],
      },
      {
        title: "Ostala pića",
        engTitle: "Other drinks",
        paragraphs: [
          {
            title: "Vermut, Vodka, Vinjak, Džin, Pelinkovac",
            engTitle: "Vermouth, Vodka, Brandy, Gin, Pelinkovac",
          },
        ],
      },
      {
        title: "Kafa",
        engTitle: "Coffee",
        paragraphs: [
          {
            title: "Kafa domaća, Kafa espresso, Nes kafa",
            engTitle: "Turkish coffee, Espresso, Nescafé",
          },
        ],
      },
      {
        title: "Strana pića",
        engTitle: "International spirits",
        paragraphs: [
          {
            title:
              "Martini, Campari, Tequila, Jägermeister, Ballantine’s, Johnnie Walker, Aperol špricer",
            engTitle:
              "Martini, Campari, Tequila, Jägermeister, Ballantine’s, Johnnie Walker, Aperol spritz",
          },
        ],
      },
    ],
  },
  // 42€ end

  // 50€ start
  {
    title: "predjelo",
    engTitle: "appetizers",
    category: "50",
    subTitle: [
      {
        title: "mesni proizvodi",
        engTitle: "cured meats",
        paragraphs: [
          {
            title:
              "Pršuta Njeguška, Svinjska pečenica, Goveđa pečenica, Kulen, Budimska",
            engTitle:
              "Njeguši prosciutto, pork loin, beef prosciutto, kulen sausage, budim sausage",
          },
        ],
      },
      {
        title: "sirevi",
        engTitle: "cheeses",
        paragraphs: [
          {
            title: "Kajmak, Mladi sir, Urnebes, Kačkavalj",
            engTitle:
              "kajmak, fresh cheese, spicy cheese spread (urneves), kashkaval",
          },
        ],
      },
      {
        title: "dodaci",
        engTitle: "extras",
        paragraphs: [
          {
            title: "Masline",
            engTitle: "olives",
          },
        ],
      },
      {
        title: "peciva",
        engTitle: "pastries",
        paragraphs: [
          {
            title: "Proja, Pite sa mesom, Pite sa sirom",
            engTitle: "cornbread, meat pie, cheese pie",
          },
        ],
      },
    ],
  },
  {
    title: "Salata",
    engTitle: "salads",
    category: "50",
    subTitle: [
      {
        title: "Sezonska salata",
        engTitle: "seasonal salad",
        paragraphs: [
          {
            title: "Krastavac i paradajz",
            engTitle: "cucumber and tomato",
          },
        ],
      },
      {
        title: "Bašta salata",
        engTitle: "garden salad",
        paragraphs: [
          {
            title: "Paradajz, krastavac, kupus, ljuta paprika, mladi luk",
            engTitle: "tomato, cucumber, cabbage, hot pepper, spring onion",
          },
        ],
      },
    ],
  },
  {
    title: "Čorba",
    engTitle: "soups",
    category: "50",
    subTitle: [
      {
        title: "Teleća",
        engTitle: "veal soup",
      },
    ],
  },
  {
    title: "međujelo",
    engTitle: "intermediate course",
    category: "50",
    subTitle: [
      {
        title: "Punjena sušena paprika (sa mesom) + pavlaka",
        engTitle: "stuffed dried pepper with meat and sour cream",
      },
    ],
  },
  {
    title: "Glavno jelo",
    engTitle: "main course",
    category: "50",
    subTitle: [
      {
        title: "roštilj",
        engTitle: "grill",
        paragraphs: [
          {
            title:
              "Pljeskavica, Ćevapi, Vešalica, Pileće belo meso, Dimljeni vrat, Domaća kobasica, Pileći batak",
            engTitle:
              "serbian burger (pljeskavica), ćevapi, pork hanger steak, chicken breast, smoked pork neck, homemade sausage, chicken drumstick",
          },
        ],
      },
      {
        title: "Teleći medaljoni sa vrganjima i šampinjonima",
        engTitle: "veal medallions with porcini and champignon mushrooms",
      },
      {
        title: "Ćuretina sa mlincima",
        engTitle: "turkey with mlinci",
      },
      {
        title: "prilog",
        engTitle: "side dish",
        paragraphs: [
          {
            title: "Pekarski krompir",
            engTitle: "baked potatoes",
          },
        ],
      },
    ],
  },
  {
    title: "pečenje",
    engTitle: "roast meats",
    category: "50",
    subTitle: [
      {
        title: "Svinjsko pečenje",
        engTitle: "roast pork",
      },
      {
        title: "Jagnjeće pečenje",
        engTitle: "roast lamb",
      },
      {
        title: "prilog",
        engTitle: "side dish",
        paragraphs: [
          {
            title: "Pekarski krompir",
            engTitle: "baked potatoes",
          },
        ],
      },
    ],
  },
  {
    title: "Razne vrste peciva",
    engTitle: "various types of bread and pastries",
    category: "50",
  },
  {
    title: "Piće",
    engTitle: "drinks",
    category: "50",
    subTitle: [
      {
        title: "rakije",
        engTitle: "rakija",
        paragraphs: [
          {
            title: "Dunja, Kajsija, Šljiva, Loza, Viljamovka",
            engTitle: "quince, apricot, plum, grape, williams pear",
          },
        ],
      },
      {
        title: "medene rakije",
        engTitle: "honey rakija",
        paragraphs: [
          {
            title: "Malina, Dunja",
            engTitle: "raspberry, quince",
          },
        ],
      },
      {
        title: "vina",
        engTitle: "wine",
        paragraphs: [
          {
            title:
              "Crveno vino 0,7l, Roze vino 0,7l, Belo vino 0,7l ( Vinarija Oplenac )",
            engTitle:
              "red wine 0.7l, rosé wine 0.7l, white wine 0.7l (Oplenac winery)",
          },
        ],
      },
      {
        title: "pivo",
        engTitle: "beer",
        paragraphs: [
          {
            title:
              "Lav Premium 0,33l, Lav točeno 0,33l, Tuborg 0.33l, Budweiser tamno 0.33l, Carlsberg 0.25l",
            engTitle:
              "Lav Premium 0.33l, Lav draught 0.33l, Tuborg 0.33l, Budweiser dark 0.33l, Carlsberg 0.25l",
          },
        ],
      },
      {
        title: "voda",
        engTitle: "water",
        paragraphs: [
          {
            title: "Knjaz Miloš gazirana, Aqua Viva negazirana",
            engTitle:
              "Knjaz Miloš sparkling mineral water, Aqua Viva still water",
          },
        ],
      },
      {
        title: "sokovi",
        engTitle: "soft drinks",
        paragraphs: [
          {
            title:
              "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Jabuka, Jagoda, Breskva, Đus",
            engTitle:
              "Coca-Cola 0.25l, Coca-Cola Zero 0.25l, Fanta 0.25l, Bitter Lemon 0.25l, Tonic Water 0.25l, Sprite 0.25l, Apple, Strawberry, Peach, Orange juice",
          },
        ],
      },
      {
        title: "ceđeni sokovi",
        engTitle: "fresh juices",
        paragraphs: [
          {
            title: "Limunada",
            engTitle: "lemonade",
          },
        ],
      },
      {
        title: "ostala pića",
        engTitle: "other drinks",
        paragraphs: [
          {
            title: "Vermut, Vodka, Vinjak, Džin, Pelinkovac",
            engTitle: "vermouth, vodka, brandy, gin, pelinkovac",
          },
        ],
      },
      {
        title: "kafa",
        engTitle: "coffee",
        paragraphs: [
          {
            title: "Kafa domaća, Kafa espresso, Nes kafa",
            engTitle: "turkish coffee, espresso, nescafé",
          },
        ],
      },
      {
        title: "strana pića",
        engTitle: "international spirits",
        paragraphs: [
          {
            title:
              "Martini, Campari, Tequila, Jägermeister, Ballantine’s, Johnnie Walker, Aperol špricer, Jameson",
            engTitle:
              "martini, campari, tequila, jägermeister, ballantine’s, johnnie walker, aperol spritz, jameson",
          },
        ],
      },
    ],
  },
  // 50€ end

  // 40€ start
  {
    title: "predjelo",
    engTitle: "appetizers",
    category: "40",
    subTitle: [
      {
        title: "mesni proizvodi",
        engTitle: "cured meats",
        paragraphs: [
          {
            title:
              "Pršuta Njeguška, Svinjska pečenica, Goveđa pečenica, Kulen, Budimska",
            engTitle:
              "Njeguši prosciutto, pork loin, beef prosciutto, kulen sausage, budim sausage",
          },
        ],
      },
      {
        title: "sirevi",
        engTitle: "cheeses",
        paragraphs: [
          {
            title: "Kajmak, Mladi sir, Urnebes, Kačkavalj",
            engTitle:
              "kajmak, fresh cheese, spicy cheese spread (urne bes), kashkaval",
          },
        ],
      },
      {
        title: "dodaci",
        engTitle: "extras",
        paragraphs: [
          {
            title: "Masline",
            engTitle: "olives",
          },
        ],
      },
      {
        title: "peciva",
        engTitle: "pastries",
        paragraphs: [
          {
            title: "Proja",
            engTitle: "cornbread",
          },
        ],
      },
    ],
  },
  {
    title: "salata",
    engTitle: "salads",
    category: "40",
    subTitle: [
      {
        title: "Sezonska salata",
        engTitle: "seasonal salad",
        paragraphs: [
          {
            title: "Krastavac i paradajz",
            engTitle: "cucumber and tomato",
          },
        ],
      },
      {
        title: "Bašta salata",
        engTitle: "garden salad",
        paragraphs: [
          {
            title: "Paradajz, krastavac, kupus, ljuta paprika, mladi luk",
            engTitle: "tomato, cucumber, cabbage, hot pepper, spring onion",
          },
        ],
      },
    ],
  },
  {
    title: "Čorba",
    engTitle: "soups",
    category: "40",
    subTitle: [
      {
        title: "Teleća",
        engTitle: "veal soup",
      },
    ],
  },
  {
    title: "Glavno jelo",
    engTitle: "main course",
    category: "40",
    subTitle: [
      {
        title: "roštilj",
        engTitle: "grill",
        paragraphs: [
          {
            title:
              "Pljeskavica, Ćevapi, Vešalica, Pileće belo meso, Dimljeni vrat, Domaća kobasica, Pileći batak",
            engTitle:
              "serbian burger (pljeskavica), ćevapi, pork hanger steak, chicken breast, smoked pork neck, homemade sausage, chicken drumstick",
          },
        ],
      },
      {
        title: "Teleći medaljoni sa vrganjima i šampinjonima",
        engTitle: "veal medallions with porcini and champignon mushrooms",
      },
      {
        title: "Ćuretina sa mlincima",
        engTitle: "turkey with mlinci",
      },
    ],
  },
  {
    title: "Piće",
    engTitle: "drinks",
    category: "40",
    subTitle: [
      {
        title: "rakije",
        engTitle: "rakija",
        paragraphs: [
          {
            title: "Dunja, Kajsija, Šljiva, Loza, Viljamovka",
            engTitle: "quince, apricot, plum, grape, williams pear",
          },
        ],
      },
      {
        title: "vina",
        engTitle: "wine",
        paragraphs: [
          {
            title:
              "Crveno vino 0.7l, Roze vino 0.7l, Belo vino 0.7l (Vinarija Oplenac)",
            engTitle:
              "red wine 0.7l, rosé wine 0.7l, white wine 0.7l (Oplenac winery)",
          },
        ],
      },
      {
        title: "pivo",
        engTitle: "beer",
        paragraphs: [
          {
            title:
              "Lav Premium 0.33l, Lav točeno 0.33l, Tuborg 0.33l, Budweiser tamno 0.33l",
            engTitle:
              "Lav Premium 0.33l, Lav draught 0.33l, Tuborg 0.33l, Budweiser dark 0.33l",
          },
        ],
      },
      {
        title: "voda",
        engTitle: "water",
        paragraphs: [
          {
            title: "Knjaz Miloš gazirana, Aqua Viva negazirana",
            engTitle:
              "Knjaz Miloš sparkling mineral water, Aqua Viva still water",
          },
        ],
      },
      {
        title: "sokovi",
        engTitle: "soft drinks",
        paragraphs: [
          {
            title:
              "Coca Cola, Coca Cola Zero, Fanta, Bitter Lemon, Tonic Water, Sprite, Jabuka, Jagoda, Breskva, Đus",
            engTitle:
              "Coca Cola, Coca Cola Zero, Fanta, Bitter Lemon, Tonic Water, Sprite, Apple, Strawberry, Peach, Orange juice",
          },
        ],
      },
    ],
  },
  // 40€ end

  // 44€ start
  {
    title: "predjelo",
    engTitle: "appetizers",
    category: "44",
    subTitle: [
      {
        title: "mesni proizvodi",
        engTitle: "cured meats",
        paragraphs: [
          {
            title:
              "Pršuta Njeguška, Svinjska pečenica, Goveđa pečenica, Kulen, Budimska",
            engTitle:
              "Njeguši prosciutto, pork loin, beef prosciutto, kulen sausage, budim sausage",
          },
        ],
      },
      {
        title: "sirevi",
        engTitle: "cheeses",
        paragraphs: [
          {
            title: "Kajmak, Mladi sir, Urnebes, Kačkavalj",
            engTitle:
              "kajmak, fresh cheese, spicy cheese spread (urne bes), kashkaval",
          },
        ],
      },
      {
        title: "dodaci",
        engTitle: "extras",
        paragraphs: [
          {
            title: "Masline",
            engTitle: "olives",
          },
        ],
      },
      {
        title: "peciva",
        engTitle: "pastries",
        paragraphs: [
          {
            title: "Proja, Pite sa mesom, Pite sa sirom",
            engTitle: "cornbread, meat pie, cheese pie",
          },
        ],
      },
    ],
  },
  {
    title: "salata",
    engTitle: "salads",
    category: "44",
    subTitle: [
      {
        title: "Sezonska salata",
        engTitle: "seasonal salad",
        paragraphs: [
          {
            title: "Krastavac i paradajz",
            engTitle: "cucumber and tomato",
          },
        ],
      },
      {
        title: "Bašta salata",
        engTitle: "garden salad",
        paragraphs: [
          {
            title: "Paradajz, krastavac, kupus, ljuta paprika, mladi luk",
            engTitle: "tomato, cucumber, cabbage, hot pepper, spring onion",
          },
        ],
      },
    ],
  },
  {
    title: "Čorba",
    engTitle: "soups",
    category: "44",
    subTitle: [
      {
        title: "Teleća",
        engTitle: "veal soup",
      },
    ],
  },
  {
    title: "međujelo",
    engTitle: "intermediate course",
    category: "44",
    subTitle: [
      {
        title: "Punjene sušene paprike (sa mesom) + pavlaka",
        engTitle: "stuffed dried peppers with meat and sour cream",
      },
    ],
  },
  {
    title: "Glavno jelo",
    engTitle: "main course",
    category: "44",
    subTitle: [
      {
        title: "roštilj",
        engTitle: "grill",
        paragraphs: [
          {
            title:
              "Pljeskavica, Ćevapi, Vešalica, Pileće belo meso, Dimljeni vrat, Domaća kobasica, Pileći batak",
            engTitle:
              "serbian burger (pljeskavica), ćevapi, pork hanger steak, chicken breast, smoked pork neck, homemade sausage, chicken drumstick",
          },
        ],
      },
      {
        title: "Ćuretina sa mlincima",
        engTitle: "turkey with mlinci",
      },
      {
        title: "prilog",
        engTitle: "side dish",
        paragraphs: [
          {
            title: "Pekarski krompir",
            engTitle: "baked potatoes",
          },
        ],
      },
    ],
  },
  {
    title: "Razne vrste peciva",
    engTitle: "various types of bread and pastries",
    category: "44",
  },
  {
    title: "Piće",
    engTitle: "drinks",
    category: "44",
    subTitle: [
      {
        title: "rakije",
        engTitle: "rakija",
        paragraphs: [
          {
            title: "Dunja, Kajsija, Šljiva, Loza, Viljamovka",
            engTitle: "quince, apricot, plum, grape, williams pear",
          },
        ],
      },
      {
        title: "vina",
        engTitle: "wine",
        paragraphs: [
          {
            title:
              "Crveno vino 0.7l, Roze vino 0.7l, Belo vino 0.7l (Vinarija Oplenac)",
            engTitle:
              "red wine 0.7l, rosé wine 0.7l, white wine 0.7l (Oplenac winery)",
          },
        ],
      },
      {
        title: "pivo",
        engTitle: "beer",
        paragraphs: [
          {
            title:
              "Lav Premium 0.33l, Lav točeno 0.33l, Tuborg 0.33l, Budweiser tamno 0.33l, Carlsberg 0.25l",
            engTitle:
              "Lav Premium 0.33l, Lav draught 0.33l, Tuborg 0.33l, Budweiser dark 0.33l, Carlsberg 0.25l",
          },
        ],
      },
      {
        title: "voda",
        engTitle: "water",
        paragraphs: [
          {
            title: "Knjaz Miloš gazirana, Aqua Viva negazirana",
            engTitle:
              "Knjaz Miloš sparkling mineral water, Aqua Viva still water",
          },
        ],
      },
      {
        title: "sokovi",
        engTitle: "soft drinks",
        paragraphs: [
          {
            title:
              "Coca Cola, Coca Cola Zero, Fanta, Bitter Lemon, Tonic Water, Sprite, Jabuka, Jagoda, Breskva, Đus",
            engTitle:
              "Coca Cola, Coca Cola Zero, Fanta, Bitter Lemon, Tonic Water, Sprite, Apple, Strawberry, Peach, Orange juice",
          },
        ],
      },
      {
        title: "ostala pića",
        engTitle: "other drinks",
        paragraphs: [
          {
            title: "Vermut, Vodka, Vinjak, Džin, Pelinkovac",
            engTitle: "vermouth, vodka, brandy, gin, pelinkovac",
          },
        ],
      },
      {
        title: "kafa",
        engTitle: "coffee",
        paragraphs: [
          {
            title: "Kafa domaća, Kafa espresso, Nes kafa",
            engTitle: "turkish coffee, espresso, nescafé",
          },
        ],
      },
      {
        title: "medene rakije",
        engTitle: "honey rakija",
        paragraphs: [
          {
            title: "Malina, Dunja",
            engTitle: "raspberry, quince",
          },
        ],
      },
      {
        title: "strana pića",
        engTitle: "international spirits",
        paragraphs: [
          {
            title: "Martini, Campari, Tequila, Jägermeister, Ballantines",
            engTitle: "martini, campari, tequila, jägermeister, ballantine’s",
          },
        ],
      },
    ],
  },
  // 44€ end

  // 49€ start
  {
    title: "predjelo",
    engTitle: "appetizers",
    category: "49",
    subTitle: [
      {
        title: "mesni proizvodi",
        engTitle: "cured meats",
        paragraphs: [
          {
            title:
              "Pršuta Njeguška, Svinjska pečenica, Goveđa pečenica, Kulen, Budimska",
            engTitle:
              "Njeguši prosciutto, pork loin, beef prosciutto, kulen sausage, budim sausage",
          },
        ],
      },
      {
        title: "sirevi",
        engTitle: "cheeses",
        paragraphs: [
          {
            title: "Kajmak, Mladi sir, Urnebes, Kačkavalj",
            engTitle:
              "kajmak, fresh cheese, spicy cheese spread (urne bes), kashkaval",
          },
        ],
      },
      {
        title: "dodaci",
        engTitle: "extras",
        paragraphs: [
          {
            title: "Masline",
            engTitle: "olives",
          },
        ],
      },
      {
        title: "peciva",
        engTitle: "pastries",
        paragraphs: [
          {
            title: "Proja, Pite sa mesom, Pite sa sirom",
            engTitle: "cornbread, meat pie, cheese pie",
          },
        ],
      },
    ],
  },
  {
    title: "salata",
    engTitle: "salads",
    category: "49",
    subTitle: [
      {
        title: "Sezonska salata",
        engTitle: "seasonal salad",
        paragraphs: [
          {
            title: "Krastavac i paradajz",
            engTitle: "cucumber and tomato",
          },
        ],
      },
      {
        title: "Bašta salata",
        engTitle: "garden salad",
        paragraphs: [
          {
            title: "Paradajz, krastavac, kupus, ljuta paprika, mladi luk",
            engTitle: "tomato, cucumber, cabbage, hot pepper, spring onion",
          },
        ],
      },
    ],
  },
  {
    title: "Čorba",
    engTitle: "soups",
    category: "49",
    subTitle: [
      {
        title: "Teleća",
        engTitle: "veal soup",
      },
    ],
  },
  {
    title: "međujelo",
    engTitle: "intermediate course",
    category: "49",
    subTitle: [
      {
        title: "Punjene sušene paprike (sa mesom) + pavlaka",
        engTitle: "stuffed dried peppers with meat and sour cream",
      },
    ],
  },
  {
    title: "Glavno jelo",
    engTitle: "main course",
    category: "49",
    subTitle: [
      {
        title: "roštilj",
        engTitle: "grill",
        paragraphs: [
          {
            title:
              "Pljeskavica, Ćevapi, Vešalica, Pileće belo meso, Dimljeni vrat, Domaća kobasica, Pileći batak",
            engTitle:
              "serbian burger (pljeskavica), ćevapi, pork hanger steak, chicken breast, smoked pork neck, homemade sausage, chicken drumstick",
          },
        ],
      },
      {
        title: "pečenje",
        engTitle: "roast meat",
        paragraphs: [
          {
            title: "Praseće pečenje, Jagnjeće pečenje",
            engTitle: "roast pork, roast lamb",
          },
        ],
      },
      {
        title: "Ćuretina sa mlincima",
        engTitle: "turkey with mlinci",
      },
      {
        title: "prilog",
        engTitle: "side dish",
        paragraphs: [
          {
            title: "Pekarski krompir",
            engTitle: "baked potatoes",
          },
        ],
      },
    ],
  },
  {
    title: "Razne vrste peciva",
    engTitle: "various types of bread and pastries",
    category: "49",
  },
  {
    title: "Piće",
    engTitle: "drinks",
    category: "49",
    subTitle: [
      {
        title: "rakije",
        engTitle: "rakija",
        paragraphs: [
          {
            title: "Dunja, Kajsija, Šljiva, Loza, Viljamovka",
            engTitle: "quince, apricot, plum, grape, williams pear",
          },
        ],
      },
      {
        title: "vina",
        engTitle: "wine",
        paragraphs: [
          {
            title:
              "Crveno vino 0.7l, Roze vino 0.7l, Belo vino 0.7l (Vinarija Oplenac)",
            engTitle:
              "red wine 0.7l, rosé wine 0.7l, white wine 0.7l (Oplenac winery)",
          },
        ],
      },
      {
        title: "pivo",
        engTitle: "beer",
        paragraphs: [
          {
            title:
              "Lav Premium 0.33l, Lav točeno 0.33l, Tuborg 0.33l, Budweiser tamno 0.33l, Carlsberg 0.25l",
            engTitle:
              "Lav Premium 0.33l, Lav draught 0.33l, Tuborg 0.33l, Budweiser dark 0.33l, Carlsberg 0.25l",
          },
        ],
      },
      {
        title: "voda",
        engTitle: "water",
        paragraphs: [
          {
            title: "Knjaz Miloš gazirana, Aqua Viva negazirana",
            engTitle:
              "Knjaz Miloš sparkling mineral water, Aqua Viva still water",
          },
        ],
      },
      {
        title: "sokovi",
        engTitle: "soft drinks",
        paragraphs: [
          {
            title:
              "Coca Cola, Coca Cola Zero, Fanta, Bitter Lemon, Tonic Water, Sprite, Jabuka, Jagoda, Breskva, Đus",
            engTitle:
              "Coca Cola, Coca Cola Zero, Fanta, Bitter Lemon, Tonic Water, Sprite, Apple, Strawberry, Peach, Orange juice",
          },
        ],
      },
      {
        title: "ostala pića",
        engTitle: "other drinks",
        paragraphs: [
          {
            title: "Vermut, Vodka, Vinjak, Džin, Pelinkovac",
            engTitle: "vermouth, vodka, brandy, gin, pelinkovac",
          },
        ],
      },
      {
        title: "kafa",
        engTitle: "coffee",
        paragraphs: [
          {
            title: "Kafa domaća, Kafa espresso, Nes kafa",
            engTitle: "turkish coffee, espresso, nescafé",
          },
        ],
      },
      {
        title: "medene rakije",
        engTitle: "honey rakija",
        paragraphs: [
          {
            title: "Malina, Dunja",
            engTitle: "raspberry, quince",
          },
        ],
      },
      {
        title: "strana pića",
        engTitle: "international spirits",
        paragraphs: [
          {
            title: "Martini, Campari, Tequila, Jägermeister, Ballantines",
            engTitle: "martini, campari, tequila, jägermeister, ballantine’s",
          },
        ],
      },
    ],
  },
  // 49€ end
];

// ===================== TAB COMPONENT =====================
const HallMenuTab = ({
  title,
  engTitle,
  isActive,
  handleTabButton,
  category,
  discountPhase,
}) => {
  const { i18n } = useTranslation();
  const price = parseInt(category);

  const suffix = i18n.language === "sr" ? "po osobi" : "per person";

  return (
    <button
      className={`hall-menu-tab ${isActive ? "active" : ""}`}
      onClick={() => handleTabButton(category)}
    >
      {i18n.language === "sr" ? title : engTitle}
      <div className="price-value">
        {price.toFixed(2)}€ {suffix}
      </div>
    </button>
  );
};

// ===================== MAIN COMPONENT =====================

const HallMenuComponent = () => {
  const { i18n } = useTranslation();

  const [category, setCategory] = useState("38");
  const [content, setContent] = useState([]);

  // ===================== LOAD MENU =====================
  useEffect(() => {
    setContent(HallMenuData.filter((data) => data.category === category));
  }, [category]);

  // ===================== INTERSECTION ANIMATION =====================
  useEffect(() => {
    const faders = document.querySelectorAll(".fade-in");
    const sliders = document.querySelectorAll(".slide-in");

    const appearOptions = {
      threshold: 0,
      rootMargin: "0px 0px -200px 0px",
    };

    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("appear");
        observer.unobserve(entry.target);
      });
    }, appearOptions);

    faders.forEach((el) => appearOnScroll.observe(el));
    sliders.forEach((el) => appearOnScroll.observe(el));
  }, [content]);

  // ===================== RENDER =====================

  return (
    <div className="hall-menu-component">
      {/* HEADER */}
      <div className="hall-menu-header fade-in">
        <div className="hall-menu-header-div">Košuta</div>

        {/* CATEGORY TABS */}
        {/* <HallMenuTab
          category={"32"}
          handleTabButton={setCategory}
          isActive={category === "32"}
        /> */}
        <HallMenuTab
          category={"38"}
          handleTabButton={setCategory}
          isActive={category === "38"}
        />
        <HallMenuTab
          category={"42"}
          handleTabButton={setCategory}
          isActive={category === "42"}
        />
        <HallMenuTab
          category={"50"}
          handleTabButton={setCategory}
          isActive={category === "50"}
        />
        <HallMenuTab
          category={"40"}
          handleTabButton={setCategory}
          isActive={category === "40"}
        />
        <HallMenuTab
          category={"44"}
          handleTabButton={setCategory}
          isActive={category === "44"}
        />
        <HallMenuTab
          category={"49"}
          handleTabButton={setCategory}
          isActive={category === "49"}
        />
      </div>

      {/* CONTENT */}
      <div className="hmc-content">
        <div className="hmc-container">
          <div className="hmc-wrap slide-in from-left">
            <div className="hmc-wrap-overlay"></div>
            <div className="hmc-img">
              <LazyLoadImage src={foodImg} alt="Hrana" />
            </div>

            <div className="hmc-scroll">
              <LazyLoadImage src={kosutaLogo} alt="Logo" />
            </div>
          </div>

          <div className="hmc-menu">
            {content.map((item, index) => (
              <div className="hmc-menu-title" key={`${category}-${index}`}>
                <h1 className="slide-in from-left">
                  {i18n.language === "sr" ? item.title : item.engTitle}
                </h1>

                {item.subTitle && (
                  <div className="hmc-menu2">
                    {item.subTitle.map((subTitle, subIndex) => (
                      <div className="hmc-menu-sub" key={subIndex}>
                        <h3 className="slide-in from-left">
                          {i18n.language === "sr"
                            ? subTitle.title
                            : subTitle.engTitle}
                        </h3>

                        <div className="hmc-menu3">
                          {subTitle.paragraphs?.map((paragraph, parIndex) => (
                            <p key={parIndex} className="slide-in from-left">
                              {i18n.language === "sr"
                                ? paragraph.title
                                : paragraph.engTitle}
                            </p>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HallMenuComponent;
